// ============================================================
// ByOurConsent.com -- Disclaimer
// /disclaimer
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8b6a3a', marginBottom: '8px' }}>
            {title}
        </div>
        <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
            {children}
        </div>
    </div>
);

const DisclaimerPage = () => (
    <>
        <Helmet><title>Disclaimer — By Our Consent</title></Helmet>
        <Nav />

        <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>Disclaimer</h1>
                <p style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '8px', lineHeight: 1.6 }}>
                    By Our Consent is committed to factual, non-partisan civic journalism.
                    This page explains our editorial standards and the limits of our responsibility
                    for contributed content.
                </p>
            </div>
        </div>

        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

            {/* Key disclaimer -- prominent */}
            <div style={{ background: '#f5f0e8', border: '0.5px solid #c8beaa', borderLeft: '3px solid #8b1a1a', borderRadius: '4px', padding: '1.5rem', marginBottom: '2rem' }}>
                <div style={{ fontSize: '17px', fontWeight: 600, color: '#1e2a3a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '8px' }}>
                    Contributor opinions
                </div>
                <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
                    Articles and posts written by contributors represent the views and opinions
                    of the individual authors only. They do not necessarily reflect the official
                    position, policy, or views of By Our Consent or its editorial team.
                    By Our Consent does not endorse any specific political party, candidate,
                    or political ideology.
                </div>
            </div>

            <Section title="Editorial standards">
                By Our Consent strives to publish content that is factually accurate,
                non-partisan, and grounded in constitutional principles. Our editorial team
                reviews submitted articles for factual accuracy and adherence to our community
                standards before publication. However, we cannot guarantee the accuracy of
                all claims made by contributors and encourage readers to verify information
                from primary sources.
            </Section>

            <Section title="Not legal advice">
                Nothing on this platform constitutes legal advice. Articles discussing
                constitutional law, statutes, court decisions, or legal rights are for
                informational and educational purposes only. For legal matters, consult
                a qualified attorney licensed in your jurisdiction.
            </Section>

            <Section title="Not financial advice">
                Nothing on this platform constitutes financial or investment advice.
                Any discussion of government spending, economic policy, or financial matters
                is for informational purposes only.
            </Section>

            <Section title="Accuracy and corrections">
                We take accuracy seriously. If you believe an article contains a factual
                error, please contact us at{' '}
                <a href="mailto:info@byourconsent.com" style={{ color: '#8b1a1a' }}>info@byourconsent.com</a>
                {' '}with the specific claim and supporting evidence. We will review and
                issue corrections where warranted.
            </Section>

            <Section title="Non-partisan commitment">
                By Our Consent is non-partisan. We do not endorse candidates, parties, or
                political movements. Our mission is to inform citizens about constitutional
                governance and hold all elected officials — regardless of party — accountable
                to the law and to the people they represent.
            </Section>

            <Section title="External links">
                This platform may contain links to external websites. These links are provided
                for informational purposes only. By Our Consent does not endorse and is not
                responsible for the content of external sites.
            </Section>

            <Section title="Contact">
                Questions or concerns about our content? <Link to="/contact" style={{ color: '#8b1a1a' }}>Contact us</Link>.
            </Section>

        </div>
        <Footer />
    </>
);

export default DisclaimerPage;
